import React from "react";
import PolicyTable from "../../component/PolicyTable";
import { Stack, Button, Container } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  isFromEditPolicy,
  isFromEditPolicyData,
} from "../../redux/Reducers/AdminPolicyReducer";
import { strings, paths } from "../../utils/constants";

export default function PolicyManagementPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const addHandler = () => {
    dispatch(isFromEditPolicy(false));
    dispatch(isFromEditPolicyData({}));
    navigate(paths.adminRoutes.ASS_EDIT_POLICY);
  };
  return (
    <>
      <Container
        style={{ width: "80%", marginRight: "4%", marginBottom: "12px" }}
      >
        <Stack direction="column" alignItems="end">
          <Button
            variant="contained"
            sx={{ color: "#184437" }}
            className="button"
            startIcon={<AddIcon />}
            onClick={addHandler}
          >
            {strings.general.ADD_NEW}
          </Button>
        </Stack>
      </Container>
      <PolicyTable />;
    </>
  );
}
